import { useEffect, useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Box } from 'components/common/box';
import { EmptyIndicator, MoreOptions, Pagination } from 'components/common';
import {
  CalendarEventAttachmentsAdd,
  CalendarEventAttachmentsList,
  CalendarEventAttachmentsRemove
} from '.';

const CalendarEventAttachments = () => {
  const {
    messages,
    pageState: { calendarEvent }
  } = useReduxState();

  const [page, setPage] = useState(1);

  const { data, updateData, loading } = useApiData({
    url: `/admin/calendar-events/${calendarEvent.id}/attachments?page=${page}`
  });

  useEffect(() => {
    updateData();
  }, [page]);

  const tooltip =
    calendarEvent.visibility === 'public'
      ? messages.eventCalendarAttachmentsTooltipPublic
      : messages.eventCalendarAttachmentsTooltip;

  return (
    <>
      <Box
        headerContent={
          <div>
            <CalendarEventAttachmentsAdd updateFiles={updateData} />
            <MoreOptions category="lighter" style={{ marginLeft: 10 }}>
              <CalendarEventAttachmentsRemove updateFiles={updateData} />
            </MoreOptions>
          </div>
        }
        loading={loading}
        padding={0}
        title={messages.commonFiles}
        titleTooltip={tooltip}
      >
        {data?.attachments?.length ? (
          <CalendarEventAttachmentsList
            attachments={data.attachments}
            updateFiles={updateData}
          />
        ) : (
          <EmptyIndicator icon="file" title={messages.siteSettingsFilesEmpty} />
        )}
      </Box>

      <Pagination
        currentPage={page}
        numberOfPages={data?.pages || 1}
        onPageChange={({ page }) => setPage(page)}
      />
    </>
  );
};

export default CalendarEventAttachments;
